import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getServiceDefinitions, getServiceTypes } from 'wasp/client/operations';

export default function ServiceDefinitionListPage() {
  const [selectedTypeId, setSelectedTypeId] = useState<string>('');
  const [searchQuery, setSearchQuery] = useState('');

  const { data: serviceTypes, isLoading: typesLoading } = getServiceTypes() as any;
  const { data: definitions, isLoading: defsLoading } = getServiceDefinitions({
    serviceTypeId: selectedTypeId || undefined,
    search: searchQuery || undefined
  }) as any;

  const isLoading = typesLoading || defsLoading;

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Service Categories
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Browse all available Community services and programs
          </p>
        </div>

        {/* Filters */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-8">
          <div className="grid gap-4 md:grid-cols-2">
            {/* Search */}
            <div>
              <label htmlFor="search" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Search
              </label>
              <input
                type="text"
                id="search"
                placeholder="Search services..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Service Type Filter */}
            <div>
              <label htmlFor="serviceType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Service Type
              </label>
              <select
                id="serviceType"
                value={selectedTypeId}
                onChange={(e) => setSelectedTypeId(e.target.value)}
                className="w-full px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
              >
                <option value="">All Types</option>
                {serviceTypes?.map((type: any) => (
                  <option key={type.id} value={type.id}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Results */}
        {isLoading ? (
          <div className="text-center py-12">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            <p className="mt-4 text-gray-600 dark:text-gray-400">Loading services...</p>
          </div>
        ) : definitions && definitions.length === 0 ? (
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-12 text-center">
            <p className="text-gray-600 dark:text-gray-400 text-lg mb-4">
              No service types found
            </p>
            <p className="text-sm text-gray-500 dark:text-gray-500">
              Try adjusting your filters or run database seed to populate sample data
            </p>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {definitions?.map((def: any) => (
              <Link
                key={def.id}
                to={`/discover-services/definitions/${def.slug}` as any}
                className="block bg-white dark:bg-gray-800 rounded-lg shadow hover:shadow-lg transition"
              >
                {def.imageUrl && (
                  <img
                    src={def.imageUrl}
                    alt={def.name}
                    className="w-full h-48 object-cover rounded-t-lg"
                  />
                )}
                <div className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        {def.name}
                      </h3>
                      <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200">
                        {def.serviceType.label}
                      </span>
                    </div>
                  </div>

                  <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-3">
                    {def.description}
                  </p>

                  <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400 pt-4 border-t border-gray-200 dark:border-gray-700">
                    <div className="flex items-center gap-4">
                      <span>{def._count?.offerings || 0} locations</span>
                      {def.typicalDuration && (
                        <span>{def.typicalDuration} min</span>
                      )}
                    </div>
                    {def.requiresBooking && (
                      <span className="text-xs px-2 py-1 bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 rounded">
                        Booking Required
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}



